/* eslint-disable */
import { Edit } from '@mui/icons-material';
import React, {
	forwardRef, useEffect, useState
} from 'react';
import { connect } from 'react-redux';
import { Download, Upload } from 'lucide-react';
import {
	classes, csvArrayToObject, getOurProductUnit, getUnitConvertedQuantity, getUnitConvertedUnit, handleExcelDownload, parseCSV,
	reverseUnitAndQtyNew
} from '../../Helpers';
// import { notificationServices } from '../../Services';
import styles from './POItemSelection.module.scss';
import TableRow from './TableRow/TableRow';
import config from '../../Pages/Analytics/CreatePurchaseOrder/CreatePurchaseOrder.config';
import { useAuth } from '../Auth/Login/auth';
import { Button } from '../ui/button';
import UploadDataModal from '../Modals/UploadDataModal/UploadDataModal';
import { modalActions } from '@/Actions';
import excel from '../../Images/excel.svg';
import { notificationServices } from '@/Services';
import inventoryAnalyticsServices from '@/Services/Analytics Services/inventory-analytics.services';

const defaultColumns = [
	{
		title: 'ITEM DETAILS',
		icon: false,
		width: '30%',
	},
	{
		title: 'UNIT',
		icon: false,
		width: false,
	},
	{
		title: 'QTY-INFO',
		icon: false,
		width: false,
	},
	{
		title: 'EXPECTED LEFT OVER',
		icon: false,
		width: '100px',
	},
	{
		title: 'QUANTITY',
		icon: <Edit className={styles.icon} />,
		width: '150px',
	},
	{
		title: 'RATE',
		icon: <Edit className={styles.icon} />,
		width: '150px',
	},
	{
		title: 'Discount%',
		icon: <Edit className={styles.icon} />,
		width: '120px',
	},
	{
		title: 'Total Discount',
		icon: false,
		width: '125px',
	},
	{
		title: 'HSN Code',
		icon: false,
		width: '125px',
	},
	{
		title: 'Batch Id',
		icon: false,
		width: '125px',
	},
	{
		title: 'TAX %',
		icon: false,
		width: '100px',
	},
	{
		title: 'Sub total',
		icon: false,
		width: '100px',
	},
	{
		title: 'Total Tax',
		icon: false,
		width: '100px',
	},
	{
		title: 'Total Amount',
		icon: false,
		width: '100px',
	},
];

const capexOrderColumns = [
	{
		title: 'S.No',
		icon: false,
		width: '10%',
	},
	{
		title: 'ITEM DETAILS',
		icon: false,
		width: '20%',
	},
	{
		title: 'SPECIFICATIONS',
		icon: <Edit className={styles.icon} />,
		width: '30%',
	},
	{
		title: 'QUANTITY',
		icon: <Edit className={styles.icon} />,
		width: '100px',
	},
	{
		title: 'RATE',
		icon: <Edit className={styles.icon} />,
		width: '100px',
	},
	{
		title: 'HSN Code',
		icon: false,
		width: '125px',
	},
	{
		title: 'TAX %',
		icon: <Edit className={styles.icon} />,
		width: '100px',
	},
	{
		title: 'Sub total',
		icon: false,
		width: '100px',
	},
	{
		title: 'Total Tax',
		icon: false,
		width: '100px',
	},
	{
		title: 'Total Amount',
		icon: false,
		width: '100px',
	},
];

// capex service column
const capexServiceColumns = [
	{
		title: 'SERVICE',
		icon: true,
		width: '25%',
	},
	{
		title: 'ASSET TYPE',
		icon: false,
		width: '15%',
	},
	{
		title: 'QUANTITY',
		icon: <Edit className={styles.icon} />,
		width: '10%',
	},
	{
		title: 'RATE',
		icon: <Edit className={styles.icon} />,
		width: '10%',
	},
	{
		title: 'SAC CODE',
		icon: false,
		width: '125px',
	},
	{
		title: 'TAX %',
		icon: <Edit className={styles.icon} />,
		width: '100px',
	},
	{
		title: 'Sub total',
		icon: false,
		width: '100px',
	},
	{
		title: 'Total Tax',
		icon: false,
		width: '100px',
	},
	{
		title: 'Total Amount',
		icon: false,
		width: '100px',
	},
];

// pack sized order columns
const packSizedOrderColumns = [
	{
		title: 'ITEM DETAILS',
		icon: false,
		width: '25%',
	},
	{
		title: 'UNIT',
		icon: false,
		width: '10%',
	},
	{
		title: 'PACK SIZE',
		icon: false,
		width: '15%',
	},
	{
		title: 'PACKS REQUIRED',
		icon: <Edit className={styles.icon} />,
		width: '15%',
	},
	{
		title: 'NO. OF PCS TO BE PACKED',
		icon: false,
		width: '20%',
	},
	// {
	// 	title: 'HSN CODE',
	// 	icon: false,
	// 	width: '125px',
	// }
];

// canOrderInPacks columns - adds PACK SIZE, QTY, and FINAL QTY alongside existing columns
const canOrderInPacksColumns = [
	{
		title: 'ITEM DETAILS',
		icon: false,
		width: '20%',
	},
	{
		title: 'UNIT',
		icon: false,
		width: '8%',
	},
	{
		title: 'QTY-INFO',
		icon: false,
		width: false,
	},
	{
		title: 'PACK SIZE',
		icon: false,
		width: '15%',
	},
	{
		title: 'QUANTITY',
		icon: <Edit className={styles.icon} />,
		width: '120px',
	},
	{
		title: 'FINAL QTY',
		icon: false,
		width: '100px',
	},
	{
		title: 'RATE',
		icon: <Edit className={styles.icon} />,
		width: '100px',
	},
	{
		title: 'Discount%',
		icon: <Edit className={styles.icon} />,
		width: '100px',
	},
	{
		title: 'Total Discount',
		icon: false,
		width: '100px',
	},
	{
		title: 'HSN Code',
		icon: false,
		width: '100px',
	},
	{
		title: 'TAX %',
		icon: false,
		width: '80px',
	},
	{
		title: 'Sub total',
		icon: false,
		width: '100px',
	},
	{
		title: 'Total Tax',
		icon: false,
		width: '100px',
	},
	{
		title: 'Total Amount',
		icon: false,
		width: '100px',
	},
];

const getProductInputUnit = (productUnit, qty) => {
	if (productUnit === 'gram') {
		return {
			productInputUnit: 'kg',
			productQtyValue: null,
		};
	}
	if ((productUnit === 'litre' || productUnit === 'ml')) {
		return {
			productInputUnit: 'ltr',
			productQtyValue: null,
		};
	}
	if (productUnit === 'oz') {
		return {
			productInputUnit: 'lbs',
			productQtyValue: null,
		};
	}
	if (productUnit === 'gram') {
		if (Math.floor(qty / 1000) > 0) {
			return {
				productInputUnit: 'kg',
				productQtyValue: qty / 1000,
			};
		}
		return {
			productInputUnit: 'g',
			productQtyValue: qty,
		};
	}
	return {
		productInputUnit: productUnit,
		productQtyValue: qty,
	};
};

const POItemSelection = forwardRef((props, ref) => {
	const {
		productsList,
		servicesList = [],
		assetsList = [],
		state,
		setState,
		skuStockInfo,
		productWiseMappingData,
		requiredFields,
		handleGenerateStandardPO,
		disabled,
		updateManualRateUpdatedVariantIds,
		ratePerString,
		toggleUploadDataModal,
		vendorPrices = {},
		defaultSelectedItems = [],
		filterColumns = ['EXPECTED LEFT OVER'],
		isDeliveryChallan = false,
		rowError = {},
		setRowError = () => { },
		typeId,
		canOrderInPacks = false,
		qtyRegex = null,
		customComponents = {},
		taxApplied = {
			isApplied: true,
			reason: '',
		},
		handleInputBlur = () => { },
		parentState = {},
		packSizedOrder = false,
	} = props;
	const [quantity, setQuantity] = useState(null);
	const { appConfig = {} } = useAuth();
	const { measurement } = appConfig?.configs || {};
	const isNagaCustomer = appConfig?.customerId;


	const fetchSuggestedQty = async (newValue, updateState) => {
		try {
			const response = await inventoryAnalyticsServices.fetchRecommendQty({
				data: {
					variantId: newValue?.selectedVariant?.id,
					storeId: parentState?.deliverTo?.id,
				},
			});
			if (response?.statusCode === 200) {
				return updateQuantity(newValue?.id, response?.data?.possibleQty, updateState);
			} else if (response?.statusCode === 201) {
				notificationServices?.generateNotification({
					type: 'warning',
					message: response?.message,
				})
				return;
			}
		} catch (error) {
			console.error('Failed to fetch recommended quantity:', error);
		}
	};

	const updateQuantity = (id, value, updateState) => {
		const newState = updateState?.map((ele) => {
			if (Number(ele?.id) === Number(id)) {
				const itemQty = Number(value);
				const subTotal = config.getSubTotal(
					ele?.selectedVariant?.price,
					ele?.discountPercentage,
					itemQty,
					ele?.productInputUnit
				);
				let totalTax = 0;
				if (taxApplied?.isApplied) {
					totalTax = config.getTotalTax(
						ele?.selectedVariant?.price,
						ele?.discountPercentage,
						ele?.tax ?? 0,
						itemQty,
						ele?.productInputUnit
					);
				}
				const totalDiscount = config.getTotalDiscount(
					ele?.selectedVariant?.price,
					ele?.discountPercentage,
					itemQty,
					ele?.productInputUnit
				);
				return {
					...ele,
					quantity: value,
					suggQty: value,
					subTotal,
					totalTax,
					totalDiscount,
					totalPriceIncTax: config.getTotalPrice(
						// ele?.selectedVariant?.price,
						// ele?.discountPercentage,
						// ele?.tax,
						// Number(value),
						// ele?.unit
						subTotal,
						totalTax
					),
				};
			}
			return {
				...ele,
			};
		});
		setState(newState);
		setRowError((prev) => {
			if (prev?.[id]) {
				return {
					...prev,
					[id]: {
						...prev?.[id],
						quantity: false,
					}
				}
			}
			return prev;
		})
	};

	const handleItemSelection = (newValue) => {
		if (newValue) {
			let itemQty = quantity;
			let updateState = [];
			const itemMoq = newValue?.selectedVariant?.pieces?.split(',')?.[0];
			let itemPrice =
				vendorPrices?.[newValue?.selectedVariant?.id] ??
				newValue?.selectedVariant?.price;
			if (newValue?.unit === 'gram' || newValue?.unit === 'ml') {
				itemPrice *= 1000;
			}
			if (newValue?.unit === 'oz') {
				itemPrice *= 16;
			}
			if (newValue?.unit === 'floz') {
				itemPrice *= 128;
			}
			if (typeId === 3 && itemMoq) {
				itemQty = Number(itemMoq);
			}
			if ((!itemQty || itemQty === 0) && typeId !== 9) {
				setRowError((prev) => {
					if (prev?.[newValue?.selectedVariant?.id]) {
						return {
							...prev,
							[newValue?.selectedVariant?.id]: {
								...prev?.[newValue?.selectedVariant?.id],
								quantity: true,
							},
						};
					}
					return {
						...prev,
						[newValue?.selectedVariant?.id]: {
							quantity: true,
						},
					};
				});
			}
			if (!itemPrice && typeId !== 9) {
				setRowError((prev) => {
					if (prev?.[newValue?.selectedVariant?.id]) {
						return {
							...prev,
							[newValue?.selectedVariant?.id]: {
								...prev?.[newValue?.selectedVariant?.id],
								rate: true,
							},
						};
					}
					return {
						...prev,
						[newValue?.selectedVariant?.id]: {
							rate: true,
						},
					};
				});
			}
			const { productInputUnit, productQtyValue } = getProductInputUnit(
				newValue?.unit,
				itemQty
			);
			const subTotal = config.getSubTotal(
				itemPrice,
				0,
				productQtyValue,
				productInputUnit
			);
			let totalTax = 0;
			if (taxApplied?.isApplied) {
				totalTax = config.getTotalTax(
					itemPrice,
					0,
					newValue?.tax ?? 0,
					productQtyValue,
					productInputUnit
				);
			}
			const totalDiscount = config.getTotalDiscount(
				itemPrice,
				0,
				productQtyValue,
				productInputUnit
			);
			const deepCopy = JSON.parse(JSON.stringify(newValue));

			// For pack-sized orders, auto-select the first unselected pack size
			let autoSelectedPackSize = null;
			if (packSizedOrder) {
				const packSizeConfig = deepCopy?.selectedVariant?.packSizeConfig || [];
				const variantId = deepCopy?.selectedVariant?.id;

				// Get pack IDs already used for this variant
				const usedPackIds = state
					?.filter((item) => item?.selectedVariant?.id === variantId && item?.selectedPackSize?.id)
					?.map((item) => item?.selectedPackSize?.id) || [];

				// Find first pack size not already used
				autoSelectedPackSize = packSizeConfig.find((pack) => !usedPackIds.includes(pack.id)) || null;
			}

			// For canOrderInPacks, auto-select the first unused pack size for this variant
			if (canOrderInPacks) {
				const packSizeConfig = deepCopy?.selectedVariant?.packSizeConfig || [];
				const variantId = deepCopy?.selectedVariant?.id;

				// Build all pack options with Unpacked as default first option
				const unpackedOption = { id: 'unpacked', quantity: 1, name: 'Unpacked' };
				const allPackOptions = [unpackedOption, ...packSizeConfig];

				// Get pack IDs already used for this variant
				const usedPackIds = state
					?.filter((item) => item?.selectedVariant?.id === variantId && item?.selectedPackSize?.id)
					?.map((item) => item?.selectedPackSize?.id) || [];

				// Find first pack size not already used
				autoSelectedPackSize = allPackOptions.find((pack) => !usedPackIds.includes(pack.id)) || null;
			}

			const newItem = {
				id: deepCopy?.selectedVariant?.id ?? deepCopy?.id,
				disabledPrice: !!vendorPrices?.[deepCopy?.selectedVariant?.id],
				productId: deepCopy?.id,
				productName: typeId === 9 ? deepCopy?.name : deepCopy?.productName,
				serviceId: deepCopy?.serviceId,
				assetId: deepCopy?.assetId,
				productImageUrl: typeId === 9 ? deepCopy?.image : deepCopy?.productImageUrl,
				variants: deepCopy?.variants,
				quantity: productQtyValue,
				unit: deepCopy?.unit,
				selectedVariant: {
					...deepCopy?.selectedVariant,
					price: itemPrice,
				},
				discountPercentage: 0,
				skuType: deepCopy?.skuType,
				tax: typeId === 9 ? deepCopy?.taxPercentage : deepCopy?.tax ?? 0,
				subTotal,
				coreSpecifications: deepCopy?.coreSpecifications,
				oems: deepCopy?.assetCategory?.oems?.map((oem) => ({
					...oem,
					client: null,
				})),
				totalTax: typeId === 9 ? deepCopy?.taxPercentage : totalTax,
				totalDiscount,
				totalPriceIncTax: config.getTotalPrice(subTotal, totalTax),
				productInputUnit,
				salesConsumptionUnit: deepCopy?.salesConsumptionUnit,
				assetCategory: deepCopy?.assetCategory,
				sacCode: deepCopy?.sacCode,
				existingItemId: null,
				// Auto-select pack size for pack-sized orders and canOrderInPacks
				selectedPackSize: autoSelectedPackSize,
			};
			updateState = [...state, newItem];
			setState(updateState);

			typeId == 1 && fetchSuggestedQty(newItem, updateState)
			// setQuantity(1);
		}
	};

	const handleItemUpdate = (id, newValue) => {
		if (!newValue) return;

		// Find the index of the item to update
		const itemIndex = state.findIndex(item => item.id === id);
		if (itemIndex === -1) return;

		// Get the current item to preserve its state
		const currentItem = state[itemIndex];

		// Perform the same calculations as in handleItemSelection
		let itemQty = quantity;
		const itemMoq = newValue?.selectedVariant?.pieces?.split(',')?.[0];
		let itemPrice = newValue?.productCost ??
			vendorPrices?.[newValue?.selectedVariant?.id] ??
			newValue?.selectedVariant?.price;

		// Unit conversions
		if (newValue?.unit === 'gram' || newValue?.unit === 'ml') {
			itemPrice *= 1000;
		}
		if (newValue?.unit === 'oz') {
			itemPrice *= 16;
		}
		if (newValue?.unit === 'floz') {
			itemPrice *= 128;
		}

		if (typeId === 3 && itemMoq) {
			itemQty = Number(itemMoq);
		}
		// Error handling (same as original)
		if ((!itemQty || itemQty === 0) && typeId !== 9) {
			setRowError((prev) => {
				if (prev?.[newValue?.selectedVariant?.id]) {
					return {
						...prev,
						[newValue?.selectedVariant?.id]: {
							...prev?.[newValue?.selectedVariant?.id],
							quantity: true,
						},
					};
				}
				return {
					...prev,
					[newValue?.selectedVariant?.id]: {
						quantity: true,
					},
				};
			});
		}

		if (!itemPrice) {
			setRowError((prev) => {
				if (prev?.[newValue?.selectedVariant?.id]) {
					return {
						...prev,
						[newValue?.selectedVariant?.id]: {
							...prev?.[newValue?.selectedVariant?.id],
							rate: true,
						},
					};
				}
				return {
					...prev,
					[newValue?.selectedVariant?.id]: {
						rate: true,
					},
				};
			});
		}

		const { productInputUnit, productQtyValue } = getProductInputUnit(
			newValue?.unit,
			itemQty
		);

		const subTotal = config.getSubTotal(
			itemPrice,
			0,
			productQtyValue,
			productInputUnit
		);

		let totalTax = 0;
		if (taxApplied?.isApplied) {
			totalTax = config.getTotalTax(
				itemPrice,
				0,
				currentItem?.tax ?? 0,
				productQtyValue,
				productInputUnit
			);
		}

		const totalDiscount = config.getTotalDiscount(
			itemPrice,
			0,
			productQtyValue,
			productInputUnit
		);

		const deepCopy = JSON.parse(JSON.stringify(newValue));

		// Create the updated item
		const updatedItem = {
			...currentItem,
			disabledPrice: !!vendorPrices?.[deepCopy?.selectedVariant?.id],
			variants: deepCopy?.variants,
			quantity: productQtyValue,
			unit: deepCopy?.unit,
			selectedVariant: {
				...deepCopy?.selectedVariant,
				price: itemPrice,
			},
			discountPercentage: 0,
			skuType: deepCopy?.skuType,
			//   tax: deepCopy?.tax,
			subTotal,
			coreSpecifications: deepCopy?.coreSpecifications,
			oems: deepCopy?.assetCategory?.oems?.map((oem) => ({
				...oem,
				client: null,
			})),
			//   totalTax: typeId === 9 ? deepCopy?.taxPercentage : totalTax,
			totalDiscount,
			totalPriceIncTax: config.getTotalPrice(subTotal, totalTax),
			productInputUnit,
			salesConsumptionUnit: deepCopy?.salesConsumptionUnit,
			assetCategory: deepCopy?.assetCategory,
			assetTypeInfo: { ...newValue },
			price: itemPrice,
			sacCode: currentItem?.sacCode,
			productCost: itemPrice,
			//   id: id,
			existingItemId: null
		};

		// Update the state with the new item
		const newState = [...state];
		newState[itemIndex] = updatedItem;
		setState(newState);
	};


	const handleItemServiceSelection = (selectedItems) => {
		const newSelectedItemsState = [];

		selectedItems?.forEach((item, index) => {
			// Create basic assetTypeInfo object with available data
			const assetTypeInfo = {
				productImageUrl: item?.assetImageUrl,
				name: item?.assetName,
				id: item?.assetId
				// name: assetsList?.find(e => e?.id === ),
				// Add any other basic asset info you might need
			};

			// Calculate financial values
			const itemPrice = item?.productCost || item?.variantVendorPrice || item?.price || 0;
			const subTotal = config.getSubTotal(
				itemPrice,
				item?.discountPercentage,
				item?.qty,
				item?.unit
			);

			let totalTax = 0;
			if (taxApplied?.isApplied) {
				totalTax = config.getTotalTax(
					itemPrice,
					item?.discountPercentage,
					item?.tax || item?.taxPercentage || 0,
					item?.qty,
					item?.unit
				);
			}

			const totalDiscount = config.getTotalDiscount(
				itemPrice,
				item?.discountPercentage,
				item?.qty,
				item?.unit
			);



			// Create the new item object
			const newItem = {
				id: item?.id || `item-${index}`,
				productId: item?.productId ? item?.productId : item?.serviceId || null,
				quantity: item?.qty || 1,
				unit: item?.unit || 'unit',
				assetTypeInfo, // This contains the simplified product info
				discountPercentage: item?.discountPercentage || 0,
				tax: item?.tax || item?.taxPercentage || 0,
				subTotal,
				totalTax,
				serviceId: item?.serviceId,
				assetId: item?.assetId,
				totalDiscount,
				totalPriceIncTax: config.getTotalPrice(subTotal, totalTax),
				productInputUnit: item?.unit,
				disabledPrice: item?.disabledPrice || false,
				// Include original price if needed
				price: itemPrice,
				disable: true,
				productCost: item?.productCost,
				productName: item?.productName,
				sacCode: item?.sacCode,
				productImageUrl: item?.productImageUrl,
				description: item?.description,
				selectedVariant: {
					// ...deepCopy?.selectedVariant,
					price: itemPrice,
				},
				existingItemId: item?.id
			};

			newSelectedItemsState.push(newItem);
		});

		setState([...newSelectedItemsState]);
	};

	const handleItemsListSelection = (selectedItems, isImport = false) => {
		const newSelectedItemsState = [];
		selectedItems?.forEach((ele, index) => {
			let productDetails = null;
			if (!productsList || productsList?.length === 0) {
				return;
			}
			if (!ele?.productId && ele?.variantId) {
				productDetails = productsList?.find((prod) => {
					return prod?.variants?.find((vrnt) => {
						return vrnt?.id === ele?.variantId;
					});
				});
			} else if (ele?.productId) {
				if (ele?.variantId) {
					productDetails = productsList?.find((prod) => {
						return prod?.variants?.find((vrnt) => {
							return vrnt?.id === ele?.variantId;
						});
					});
				} else {
					productDetails = productsList?.find((prod) => {
						return prod?.id === ele?.productId;
					});
				}
			}
			// const { productInputUnit, productQtyValue } = getProductInputUnit(
			// productDetails?.unit,
			// ele?.qty
			// );
			if (!productDetails) {
				// eslint-disable-next-line no-console
				console.log('error missing productDetails', ele);
				// eslint-disable-next-line no-console
				console.log('error missing selectedItems', selectedItems);
				notificationServices.generateNotification({
					type: 'error',
					message: `Missing product details at index ${index + 1}, Json: ${JSON.stringify(ele)}`,
				});
				return;
			}
			const variantDetails = productDetails?.variants?.find(
				(vrnt) => {
					return vrnt?.id === ele?.variantId;
				}
			);
			const selectedVariant = variantDetails;

			if (selectedVariant) {
				if (ele?.price) {
					selectedVariant.price = ele?.price;
				}
				if (ele?.productCost) {
					selectedVariant.price = ele?.productCost;
				}
			}
			let itemPrice =
				ele?.variantVendorPrice ?? selectedVariant?.price;

			if (isImport) {
				if (productDetails?.unit === 'gram' || productDetails?.unit === 'ml') {
					itemPrice *= 1000;
				}
				if (productDetails?.unit === 'oz') {
					itemPrice *= 16;
				}
				if (productDetails?.unit === 'floz') {
					itemPrice *= 128;
				}
			}
			const subTotal = config.getSubTotal(
				itemPrice,
				ele?.discountPercentage,
				ele?.qty,
				ele?.productInputUnit ?? ele?.unit
			);
			let totalTax = 0;
			if (taxApplied?.isApplied) {
				totalTax = config.getTotalTax(
					itemPrice,
					ele?.discountPercentage,
					ele?.tax ?? ele?.taxPercentage ?? productDetails?.tax,
					ele?.qty,
					ele?.productInputUnit ?? ele?.unit
				);
			}
			const totalDiscount = config.getTotalDiscount(
				itemPrice,
				ele?.discountPercentage,
				ele?.qty,
				ele?.productInputUnit ?? ele?.unit
			);
			const newItem = {
				id: variantDetails?.id,
				productId: productDetails?.id,
				productName: productDetails?.productName,
				productImageUrl: productDetails?.productImageUrl,
				variants: productDetails?.variants,
				quantity: ele?.qty,
				unit: productDetails?.unit,
				selectedVariant: {
					...selectedVariant,
					discountPercentage: ele?.discountPercentage,
					price: itemPrice,
				},
				skuType: productDetails?.skuType,
				discountPercentage: ele?.discountPercentage
					? ele?.discountPercentage
					: 0,
				tax: ele?.tax ?? ele?.taxPercentage ?? productDetails?.tax,
				subTotal,
				totalTax,
				totalDiscount,
				serviceId: productDetails?.serviceId,
				assetId: productDetails?.assetId,
				totalPriceIncTax: config.getTotalPrice(subTotal, totalTax),
				productInputUnit: ele?.productInputUnit ?? ele?.unit,
				salesConsumptionUnit: productDetails?.salesConsumptionUnit,
				disabledPrice: ele?.disabledPrice,
			};
			newSelectedItemsState?.push(newItem);
		});
		setState([...newSelectedItemsState]);
	};

	useEffect(() => {
		if (defaultSelectedItems && defaultSelectedItems?.length > 0 && typeId !== 9) {
			handleItemsListSelection(defaultSelectedItems);
		} else if (defaultSelectedItems && defaultSelectedItems?.length > 0 && typeId === 9) {
			handleItemServiceSelection(defaultSelectedItems)
		}
	}, [defaultSelectedItems, productsList]);

	const handleQuantity = (id, value, idx = null) => {
		if (!id) {
			setQuantity(value);
		} else {
			if (!value || !Number(value)) {
				setRowError((prev) => {
					if (prev?.[id]) {
						return {
							...prev,
							[id]: {
								...prev?.[id],
								quantity: true,
							},
						};
					}
					return {
						...prev,
						[id]: {
							quantity: true,
						},
					};
				});
			} else {
				setRowError((prev) => {
					if (prev?.[id]) {
						return {
							...prev,
							[id]: {
								...prev?.[id],
								quantity: false,
							},
						};
					}
					return {
						...prev,
						[id]: {
							quantity: false,
						},
					};
				});
			}

			// Normal flow, update quantity/subtotals as before
			if (idx !== null) {
				const newItem = state?.[idx];
				newItem.quantity = value;

				// For canOrderInPacks, calculate final qty based on pack size
				const packSizeQty = canOrderInPacks ? (newItem?.selectedPackSize?.quantity || 1) : 1;
				const itemQty = Number(value);
				const finalQty = itemQty * packSizeQty;

				const subTotal = config.getSubTotal(
					newItem?.selectedVariant?.price,
					newItem?.discountPercentage,
					finalQty,
					newItem?.productInputUnit
				);
				let totalTax = 0;
				if (taxApplied?.isApplied) {
					totalTax = config.getTotalTax(
						newItem?.selectedVariant?.price,
						newItem?.discountPercentage,
						newItem?.tax ?? 0,
						finalQty,
						newItem?.productInputUnit
					);
				}
				const totalDiscount = config.getTotalDiscount(
					newItem?.selectedVariant?.price,
					newItem?.discountPercentage,
					finalQty,
					newItem?.productInputUnit
				);
				newItem.subTotal = subTotal;
				newItem.totalTax = totalTax;
				newItem.totalDiscount = totalDiscount;
				newItem.totalPriceIncTax = config.getTotalPrice(
					subTotal,
					totalTax
				);
				setState([...state]);
				return;
			}

			const newState = state?.map((ele) => {
				if (ele?.id === id) {
					// For canOrderInPacks, calculate final qty based on pack size
					const packSizeQty = canOrderInPacks ? (ele?.selectedPackSize?.quantity || 1) : 1;
					const itemQty = Number(value);
					const finalQty = itemQty * packSizeQty;

					const subTotal = config.getSubTotal(
						ele?.selectedVariant?.price,
						ele?.discountPercentage,
						finalQty,
						ele?.productInputUnit
					);
					let totalTax = 0;
					if (taxApplied?.isApplied) {
						totalTax = config.getTotalTax(
							ele?.selectedVariant?.price,
							ele?.discountPercentage,
							ele?.tax ?? 0,
							finalQty,
							ele?.productInputUnit
						);
					}
					const totalDiscount = config.getTotalDiscount(
						ele?.selectedVariant?.price,
						ele?.discountPercentage,
						finalQty,
						ele?.productInputUnit
					);
					return {
						...ele,
						quantity: value,
						subTotal,
						totalTax,
						totalDiscount,
						totalPriceIncTax: config.getTotalPrice(
							subTotal,
							totalTax
						),
					};
				}
				return {
					...ele,
				};
			});
			setState(newState);
		}
	};

	// New batchId handler
	const handleBatchId = (id, batchId, idx = null) => {
		if (batchId === null || batchId === undefined) return;
		if (idx !== null) {
			const newItem = state?.[idx];
			newItem.extraData = {
				...(newItem.extraData || {}),
				batchId: batchId,
			};
			setState([...state]);
		} else {
			const newState = state?.map((ele) => {
				if (ele?.id === id) {
					return {
						...ele,
						extraData: {
							...(ele.extraData || {}),
							batchId: batchId,
						},
					};
				}
				return { ...ele };
			});
			setState(newState);
		}
	};

	const handleItemDescription = (id, value) => {
		const newState = state?.map((ele) => {
			if (ele?.id === id) {
				return {
					...ele,
					description: value?.target?.value,
				};
			}
			return {
				...ele,
			};
		});
		setState(newState);
	};

	const handleRemove = (product, removedIdx) => {
		const newState = state?.filter((ele, idx) => {
			if ((typeId === 4 || typeId === 9 || typeId === 7) || packSizedOrder || canOrderInPacks) {
				if (idx === removedIdx) return false;
				return true;
			}
			return ele?.id !== product?.id;
		});
		if (rowError?.[product?.id]) {
			setRowError((prev) => {
				if (prev?.[product?.id]) {
					return {
						...prev,
						[product?.id]: {},
					};
				}
				return {
					...prev,
				};
			});
		}
		setState(newState);
	};

	const handleRate = (id, value, idx = null) => {
		// eslint-disable-next-line no-useless-escape
		// const reg = new RegExp('^[0-9]+$');
		if (!value || !Number(value)) {
			setRowError((prev) => {
				if (prev?.[id]) {
					return {
						...prev,
						[id]: {
							...prev?.[id],
							rate: true,
						},
					};
				}
				return {
					...prev,
					[id]: {
						rate: true,
					},
				};
			});
		} else {
			setRowError((prev) => {
				if (prev?.[id]) {
					return {
						...prev,
						[id]: {
							...prev?.[id],
							rate: false,
						},
					};
				}
				return {
					...prev,
					[id]: {
						rate: false,
					},
				};
			});
		}
		if (idx !== null) {
			const newItem = state?.[idx];
			newItem.selectedVariant.price = value === '' ? '' : value;

			// For canOrderInPacks, calculate final qty based on pack size
			const packSizeQty = canOrderInPacks ? (newItem?.selectedPackSize?.quantity || 1) : 1;
			const itemQty = Number(newItem?.quantity || 0);
			const finalQty = canOrderInPacks ? itemQty * packSizeQty : newItem?.quantity;

			const subTotal = config.getSubTotal(
				Number(value),
				newItem?.discountPercentage,
				finalQty,
				newItem?.productInputUnit
			);
			let totalTax = 0;
			if (taxApplied?.isApplied) {
				totalTax = config.getTotalTax(
					Number(value),
					newItem?.discountPercentage,
					newItem?.tax ?? 0,
					finalQty,
					newItem?.productInputUnit
				);
			}
			const totalDiscount = config.getTotalDiscount(
				Number(value),
				newItem?.discountPercentage,
				finalQty,
				newItem?.productInputUnit
			);
			newItem.subTotal = subTotal;
			newItem.totalTax = totalTax;
			newItem.totalDiscount = totalDiscount;
			newItem.totalPriceIncTax = config.getTotalPrice(subTotal, totalTax);
			setState([...state]);
			updateManualRateUpdatedVariantIds(idx);
			return;
		}
		if (id && value !== '') {
			const newState = state?.map((ele) => {
				if (ele?.id === id) {
					// For canOrderInPacks, calculate final qty based on pack size
					const packSizeQty = canOrderInPacks ? (ele?.selectedPackSize?.quantity || 1) : 1;
					const itemQty = Number(ele?.quantity || 0);
					const finalQty = canOrderInPacks ? itemQty * packSizeQty : ele?.quantity;

					const subTotal = config.getSubTotal(
						Number(value),
						ele?.discountPercentage,
						finalQty,
						ele?.productInputUnit
					);
					let totalTax = 0;
					if (taxApplied?.isApplied) {
						totalTax = config.getTotalTax(
							Number(value),
							ele?.discountPercentage,
							ele?.tax ?? 0,
							finalQty,
							ele?.productInputUnit
						);
					}
					const totalDiscount = config.getTotalDiscount(
						Number(value),
						ele?.discountPercentage,
						finalQty,
						ele?.productInputUnit
					);
					return {
						...ele,
						selectedVariant: {
							...ele?.selectedVariant,
							price: value === '' ? '' : value,
						},
						subTotal,
						totalTax,
						totalDiscount,
						totalPriceIncTax: config.getTotalPrice(
							subTotal,
							totalTax
						),
					};
				}
				return {
					...ele,
				};
			});
			updateManualRateUpdatedVariantIds(id);
			setState(newState);
		}
	};

	// handleTax

	const handleTax = (id, value, idx = null) => {
		// eslint-disable-next-line no-useless-escape
		// const reg = new RegExp('^[0-9]+$');
		if (value === '') {
			const newItem = state?.[idx];
			newItem.tax = null;
			newItem.subTotal = 0;
			newItem.totalTax = 0;
			newItem.totalDiscount = 0;
			newItem.totalPriceIncTax = 0;
			setState([...state]);
			return;
		}
		if (idx !== null) {
			const newItem = state?.[idx];
			newItem.tax = value;
			const subTotal = config.getSubTotal(
				newItem?.selectedVariant?.price,
				newItem?.discountPercentage,
				newItem?.quantity,
				newItem?.productInputUnit
			);
			let totalTax = 0;
			if (taxApplied?.isApplied) {
				totalTax = config.getTotalTax(
					newItem?.selectedVariant?.price,
					newItem?.discountPercentage,
					Number(value),
					newItem?.quantity,
					newItem?.productInputUnit
				);
			}
			const totalDiscount = config.getTotalDiscount(
				newItem?.selectedVariant?.price,
				newItem?.discountPercentage,
				newItem?.quantity,
				newItem?.productInputUnit
			);
			newItem.subTotal = subTotal;
			newItem.totalTax = totalTax;
			newItem.totalDiscount = totalDiscount;
			newItem.totalPriceIncTax = config.getTotalPrice(subTotal, totalTax);
			setState([...state]);
			return;
		}
		if (id && value !== '') {
			const newState = state?.map((ele) => {
				if (ele?.id === id) {
					const subTotal = config.getSubTotal(
						ele?.selectedVariant?.price,
						ele?.discountPercentage,
						ele?.quantity,
						ele?.productInputUnit
					);
					let totalTax = 0;
					if (taxApplied?.isApplied) {
						totalTax = config.getTotalTax(
							ele?.selectedVariant?.price,
							ele?.discountPercentage,
							Number(value),
							ele?.quantity,
							ele?.productInputUnit
						);
					}
					const totalDiscount = config.getTotalDiscount(
						ele?.selectedVariant?.price,
						ele?.discountPercentage,
						ele?.quantity,
						ele?.productInputUnit
					);
					return {
						...ele,
						tax: Number(value),
						subTotal,
						totalTax,
						totalDiscount,
						totalPriceIncTax: config.getTotalPrice(
							subTotal,
							totalTax
						),
					};
				}
				return {
					...ele,
				};
			});
			setState(newState);
		}
	};
	// endhandleTax
	const handleDiscount = (id, value, idx = null) => {
		// For index-based update (canOrderInPacks)
		if (idx !== null) {
			const newItem = state?.[idx];
			if (!newItem) return;

			// For canOrderInPacks, calculate final qty based on pack size
			const packSizeQty = canOrderInPacks ? (newItem?.selectedPackSize?.quantity || 1) : 1;
			const itemQty = Number(newItem?.quantity || 0);
			const finalQty = canOrderInPacks ? itemQty * packSizeQty : newItem?.quantity;

			const subTotal = config.getSubTotal(
				newItem?.selectedVariant?.price,
				parseFloat(value),
				finalQty,
				newItem?.productInputUnit
			);
			let totalTax = 0;
			if (taxApplied?.isApplied) {
				totalTax = config.getTotalTax(
					newItem?.selectedVariant?.price,
					parseFloat(value),
					newItem?.tax ?? 0,
					finalQty,
					newItem?.productInputUnit
				);
			}
			const totalDiscount = config.getTotalDiscount(
				newItem?.selectedVariant?.price,
				parseFloat(value),
				finalQty,
				newItem?.productInputUnit
			);
			newItem.discountPercentage = value;
			newItem.subTotal = subTotal;
			newItem.totalTax = totalTax;
			newItem.totalDiscount = totalDiscount;
			newItem.totalPriceIncTax = config.getTotalPrice(subTotal, totalTax);
			setState([...state]);
			return;
		}

		if (id) {
			const newState = state?.map((ele) => {
				// For canOrderInPacks, calculate final qty based on pack size
				const packSizeQty = canOrderInPacks ? (ele?.selectedPackSize?.quantity || 1) : 1;
				const itemQty = Number(ele?.quantity || 0);
				const finalQty = canOrderInPacks ? itemQty * packSizeQty : ele?.quantity;

				const subTotal = config.getSubTotal(
					ele?.selectedVariant?.price,
					parseFloat(value),
					finalQty,
					ele?.productInputUnit
				);
				let totalTax = 0;
				if (taxApplied?.isApplied) {
					totalTax = config.getTotalTax(
						ele?.selectedVariant?.price,
						parseFloat(value),
						ele?.tax ?? 0,
						finalQty,
						ele?.productInputUnit
					);
				}
				const totalDiscount = config.getTotalDiscount(
					ele?.selectedVariant?.price,
					parseFloat(value),
					finalQty,
					ele?.productInputUnit
				);
				if (ele?.id === id) {
					return {
						...ele,
						discountPercentage: value,
						subTotal,
						totalTax,
						totalDiscount,
						totalPriceIncTax: config.getTotalPrice(
							subTotal,
							totalTax
						),
					};
				}
				return {
					...ele,
				};
			});
			setState(newState);
		}
	};

	const handleChangeVariant = (id, variant) => {
		const newState = state?.map((ele) => {
			if (ele?.id === id) {
				return {
					...ele,
					id: variant?.id,
					selectedVariant: variant,
					totalPriceIncTax: config.getTotalPrice(
						ele?.subTotal,
						ele?.totalTax
					),
				};
			}
			return {
				...ele,
			};
		});
		setState(newState);
	};

	// Handler for pack size selection in pack sized orders
	// Uses only index-based matching to prevent updating multiple rows with the same variant ID
	const handlePackSize = (id, selectedPackSize, idx) => {
		const newState = state?.map((ele, index) => {
			// Use only index-based matching for pack sized orders
			if (index === idx) {
				// For canOrderInPacks, recalculate costs with new pack size
				if (canOrderInPacks && ele?.quantity) {
					const packSizeQty = selectedPackSize?.quantity || 1;
					const itemQty = Number(ele?.quantity);
					const finalQty = itemQty * packSizeQty;

					const subTotal = config.getSubTotal(
						ele?.selectedVariant?.price,
						ele?.discountPercentage,
						finalQty,
						ele?.productInputUnit
					);
					let totalTax = 0;
					if (taxApplied?.isApplied) {
						totalTax = config.getTotalTax(
							ele?.selectedVariant?.price,
							ele?.discountPercentage,
							ele?.tax ?? 0,
							finalQty,
							ele?.productInputUnit
						);
					}
					const totalDiscount = config.getTotalDiscount(
						ele?.selectedVariant?.price,
						ele?.discountPercentage,
						finalQty,
						ele?.productInputUnit
					);
					return {
						...ele,
						selectedPackSize,
						subTotal,
						totalTax,
						totalDiscount,
						totalPriceIncTax: config.getTotalPrice(subTotal, totalTax),
					};
				}
				return {
					...ele,
					selectedPackSize,
					// Reset packs required when pack size changes
					packsRequired: '',
				};
			}
			return ele;
		});
		setState(newState);
	};

	// Handler for packs required input in pack sized orders
	// Uses variantId-packId combination for uniqueness, updated by idx for pack sized orders
	const handlePacksRequired = (variantId, packId, value, idx) => {
		const newState = state?.map((ele, index) => {
			// Use index-based update for pack sized orders to ensure unique variantId-packId mapping
			if (index === idx) {
				return {
					...ele,
					quantity: Number(value), // Use quantity field for packs required value
				};
			}
			return ele;
		});
		setState(newState);
	};

	const getRowStyles = (id, idx) => {
		if (idx % 2 === 0) {
			return styles.even;
		}
		return '';
	};

	const getBaseColumns = () => {
		if (packSizedOrder) {
			return packSizedOrderColumns;
		}

		// canOrderInPacks - show pack size columns alongside existing ones
		if (canOrderInPacks) {
			return canOrderInPacksColumns?.filter((colEle) => {
				return isNagaCustomer !== 72 ? colEle?.title !== 'Batch Id' : true;
			});
		}

		if (typeId === 4 || typeId === 7) {
			return capexOrderColumns?.filter((colEle) => {
				return !(typeId === 7 && colEle?.title === 'SPECIFICATIONS');
			});
		}

		if (typeId === 9) {
			return capexServiceColumns;
		}

		return defaultColumns?.filter((colEle) => {
			return isNagaCustomer !== 72 ? colEle?.title !== 'Batch Id' : true;
		});
	};

	const tableColumns = (getBaseColumns() || []).filter((colEle) => {
		return !filterColumns?.length || !filterColumns.includes(colEle?.title);
	});

	const handleChangeProductUnit = (id, unit) => {
		const newState = state?.map((ele) => {
			const subTotal = config.getSubTotal(
				ele?.selectedVariant?.price,
				ele?.discountPercentage,
				ele?.quantity,
				unit
			);
			let totalTax = 0;
			if (taxApplied?.isApplied) {
				totalTax = config.getTotalTax(
					ele?.selectedVariant?.price,
					ele?.discountPercentage,
					ele?.tax ?? 0,
					ele?.quantity,
					unit
				);
			}
			const totalDiscount = config.getTotalDiscount(
				ele?.selectedVariant?.price,
				ele?.discountPercentage,
				ele?.quantity,
				unit
			);
			if (ele?.id === id) {
				return {
					...ele,
					subTotal,
					totalTax,
					totalDiscount,
					productInputUnit: unit,
					totalPriceIncTax: config.getTotalPrice(
						// ele?.selectedVariant?.price,
						// ele?.discountPercentage,
						// ele?.tax,
						// Number(value),
						// ele?.unit
						subTotal,
						totalTax
					),
				};
			}
			return {
				...ele,
			};
		});
		setState(newState);
	};
	const handleSpecifications = (idx, specId, value) => {
		const newState = [...state];
		const currentItem = newState?.[idx];
		const specification = currentItem?.coreSpecifications?.find(
			(spec) => spec.id === specId
		);
		if (!specification) return;
		specification.value = value;
		setState(newState);
	};

	const handleOemSelection = (idx, selectedOemsIds) => {
		const newState = [...state];
		const currentItem = newState?.[idx];
		const previousOems = currentItem?.oems;
		previousOems?.forEach((oem) => {
			// eslint-disable-next-line no-param-reassign
			oem.isSelected = selectedOemsIds?.includes(oem?.id);
		});
		setState(newState);
	};

	const productListExcelDownload = () => {
		const item = [];
		const header = [
			'Item Code',
			'UY Item Id',
			'Product Name',
			'Variant Name',
			'Unit',
			'Quantity',
		];
		productsList.forEach((product) => {
			product?.variants?.forEach((variant) => {
				const row = [
					variant?.clientVariantId,
					variant?.id,
					product?.productName,
					variant?.displayName,
					getUnitConvertedUnit(1, product?.unit, true),
					0,
				];
				item.push(row);
			});
		});
		handleExcelDownload(header, item, 'Product List', true);
	};

	const handleImport = (fileObject) => {
		const base64 = fileObject?.file?.split?.('text/csv;base64,')[1];
		if (base64?.length === 0) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Please upload a valid CSV file, with correct headers',
			});
			return;
		}
		const decoded = atob(base64);
		const parsedData = parseCSV(decoded);
		const arr = csvArrayToObject(parsedData);
		let index = 0;
		const newState = [];
		for (const object of arr) {
			let {
				Quantity: qty,
				Unit: objUnit,
				'Item Code': itemCode,
				'UY Item Id': variantId,
			} = object;
			qty = Number(qty);
			if (Number.isNaN(qty) || ['', null, undefined, 0, '-', '0', '0.00', '0.0000'].includes(qty)) {
				// eslint-disable-next-line no-console
				console.log('skipping', qty, object);
				// eslint-disable-next-line no-continue
				continue;
			}
			if (['', null, undefined, 0, '-', '0', '0.00', '0.0000'].includes(variantId)) {
				// eslint-disable-next-line no-console
				console.log('error missing variantId', qty, object);
				notificationServices.generateNotification({
					type: 'error',
					message: `Missing variantId at index ${index + 1} and row ${itemCode} with quantity ${qty}`,
				});
				return;
			}
			if (['', null, undefined, 0, '-', '0', '0.00', '0.0000'].includes(objUnit)) {
				// eslint-disable-next-line no-console
				console.log('error missing unit', qty, object);
				notificationServices.generateNotification({
					type: 'error',
					message: `Missing unit at index ${index + 1} and row ${itemCode} with quantity ${qty}`,
				});
				return;
			}
			index++;
			// eslint-disable-next-line prefer-const
			let [unit, isHigherUnit] = getOurProductUnit(objUnit);
			if (!unit) {
				notificationServices.generateNotification({
					type: 'error',
					message: `Invalid unit (${objUnit}) at index ${index + 1} and row ${itemCode} with quantity ${qty}`,
				});
				return;
			}

			// if (isHigherUnit) {
			// const [newQty, newUnit] = reverseUnitAndQtyNew(qty, unit);
			// qty = newQty;
			// unit = newUnit;
			// }
			newState.push({
				variantId: Number(variantId),
				qty: Number(qty),
				unit,
				discountPercentage: 0,
			});
		}
		handleItemsListSelection(newState, true);
	};

	const handleItemComment = (id, value) => {
		const newState = state?.map((ele) => {
			if (ele?.id === id) {
				return {
					...ele,
					comment: value,
				};
			}
			return ele;
		});
		setState(newState);
	};

	return (
		<div className={classes(styles.root)}>
			<UploadDataModal
				fileAcceptable='.csv'
				heading='Upload items to populate list'
				handleImport={handleImport}
			/>
			{!!disabled && (
				<div
					onClick={() => {
						// notificationServices.generateNotification({
						// type: 'error',
						// message: 'Please enter Mandatory fields',
						// });
						return null;
					}}
					className={styles.disabled}
				/>
			)}
			<div className={styles['actions-container']}>
				{
					state?.length === 0 &&
					(
						<>

							<div
								onClick={() => {
									productListExcelDownload();
								}}
								className={`${styles.downloadData}`}
							>
								<img src={excel} alt='excel' />
								EXPORT
								<Upload size={18} className='text-white' />
							</div>
							<div
								onClick={() => {
									toggleUploadDataModal(true, {});
								}}
								className={`${styles.downloadData}`}
								style={{
									backgroundColor: '#3f6cff',
								}}
							>
								<img src={excel} alt='excel' />
								IMPORT
								<Download size={18} className='text-white' />
							</div>
						</>
					)
				}

				{requiredFields?.generateStandardPO && state?.length === 0 && (
					<Button
						onClick={handleGenerateStandardPO}
						className='primary-btn'
					>
						Generate Standard PO
					</Button>
				)}
			</div>

			<div className='flex flex-col gap-1 w-full items-end'>
				{(!taxApplied?.isApplied || taxApplied?.reason?.length > 0) && (
					taxApplied?.reason?.length > 0 && (
						<p className='text-uy-color font-semibold animate-pulse m-0'>
							{taxApplied?.reason}
						</p>

					)
				)}
				{typeId === 1 && (
					<p className='font-semibold text-slate-600 m-0'>
						Some prices are fixed or non-editable due to vendor
						contracts.
					</p>
				)}
			</div>
			<div className={styles['item-row']}>
				<table>
					<thead>
						<tr>
							{tableColumns?.map((ele) => {
								return (
									<th
										style={{
											width: ele?.width ? ele?.width : '',
											fontSize: 14,
										}}
									>
										{ele?.title?.toUpperCase()}
										{' '}
										{ele?.icon}
									</th>
								);
							})}
						</tr>
					</thead>
					<tbody ref={ref}>
						{state?.map((ele, idx) => {
							const unit = ele?.unit !== 'count' ? getUnitConvertedUnit(null, ele?.unit, true) : ele?.unit;
							const quantity = ele?.unit !== 'count' ? getUnitConvertedQuantity(ele?.quantity, unit, true, false, false, true) : ele?.quantity;
							const product = {
								...ele,
								quantity: quantity,
								higherUnit: unit,
							};
							const rowStyles = getRowStyles(
								ele?.selectedVariant?.id,
								idx
							);
							const isChangeable = !!ele?.isChangeable;
							return (
								<React.Fragment key={idx}>
									<TableRow
										key={
											(typeId === 4 || typeId === 9 || typeId === 7)
												? idx
												: ele?.selectedVariant?.id
										}
										idx={idx}
										customComponents={customComponents}
										handleItemDescription={
											handleItemDescription
										}
										rowStyles={rowStyles}
										product={product}
										quantity={product?.quantity}
										productWiseMappingData={
											productWiseMappingData
										}
										handleSpecifications={
											handleSpecifications
										}
										handleTax={handleTax}
										handleOemSelection={handleOemSelection}
										ratePerString={ratePerString}
										rowError={rowError}
										disabled={disabled}
										productsList={productsList}
										handleSelection={handleItemSelection}
										handleQuantity={handleQuantity}
										handleBatchId={handleBatchId}
										handleRate={handleRate}
										handleDiscount={handleDiscount}
										handleChangeVariant={
											handleChangeVariant
										}
										handleRemove={handleRemove}
										skuStockInfo={skuStockInfo}
										measurementType={measurement}
										columns={tableColumns}
										isChangeable={isChangeable}
										isDeliveryChallan={isDeliveryChallan}
										typeId={typeId}
										handleChangeProductUnit={
											handleChangeProductUnit
										}
										qtyRegex={qtyRegex}
										servicesList={servicesList}
										handleServiceAssetType={handleItemUpdate}
										assetsList={assetsList}
										disableAll={ele?.disable}
										handleInputBlur={handleInputBlur}
										handleItemComment={handleItemComment}
										handlePackSize={handlePackSize}
										handlePacksRequired={handlePacksRequired}
										packSizedOrder={packSizedOrder}
										canOrderInPacks={canOrderInPacks}
										allItems={state}
									/>
								</React.Fragment>
							);
						})}
						{!disabled && (
							<TableRow
								addedItems={state}
								disabled={disabled}
								productWiseMappingData={productWiseMappingData}
								productsList={productsList}
								servicesList={servicesList}
								assetsList={assetsList}
								handleSelection={handleItemSelection}
								handleQuantity={handleQuantity}
								quantity={quantity}
								skuStockInfo={skuStockInfo}
								columns={tableColumns}
								typeId={typeId}
								isDeliveryChallan
								handlePackSize={handlePackSize}
								handlePacksRequired={handlePacksRequired}
								packSizedOrder={packSizedOrder}
								canOrderInPacks={canOrderInPacks}
								allItems={state}
							/>
						)}
					</tbody>
				</table>
			</div>
		</div>
	);
});

const mapDispatchToProps = {
	toggleUploadDataModal: modalActions.toggleUploadDataModal,
};
export default connect(null, mapDispatchToProps)(POItemSelection);
